import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "./home.scss";
import axios from "axios";
import OrderView from "../../components/orderView/OrderView";
import SlideInModal from "../../components/slideInModal/SlideInModal";
import Loading from "../../components/loading/Loading";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectOrderId, setSelectOrderId] = useState("");
  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "createdAt", headerName: "Date", width: 100 },
    {
      field: "paymentStatus",
      headerName: "Payment Status",
      width: 100,
      renderCell: (params) => (
        <span
          style={{
            color: "#ffffffff ",
            backgroundColor:
              params.value?.toLowerCase() === "paid" ? "#5cb85c " : "red",
            fontWeight: "bold",
            padding: "10px 20px",
            borderRadius: "5px",
          }}
        >
          {params.value || "N/A"}
        </span>
      ),
    },
    { field: "orderId", headerName: "Order ID.", width: 175 },
    { field: "customer", headerName: "Customer", width: 150 },
    { field: "phone", headerName: "Phone", width: 150 },
    { field: "city", headerName: "City", width: 100 },
    { field: "address", headerName: "Address", width: 200 },
    { field: "homeName", headerName: "Home Name", width: 150 },
    { field: "landmark", headerName: "Landmark", width: 150 },
    { field: "email", headerName: "Email", width: 150 },
    { field: "brand", headerName: "Brand", width: 150 },
    { field: "totalAmount", headerName: "Total Amount", width: 120 },
    { field: "deliveryCost", headerName: "Delivery Cost", width: 120 },
    {
      field: "productsList",
      headerName: "Products",
      width: 350,
      renderCell: (params) =>
        params.value && params.value.length > 0 ? (
          <div>
            {params.value.map((p, i) => (
              <div key={i}>
                {p.name} ({p.quantity} × {p.price} AED)
              </div>
            ))}
          </div>
        ) : (
          <small>No Products</small>
        ),
    },
  ];

  useEffect(() => {
    const getAllOrders = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/get-all-orders");
        const mappedOrders = response.data.map((order) => {
          // Function to format the date
          const formatDate = (dateString) => {
            if (!dateString) return "";
            const date = new Date(dateString);
            // Customize the format (e.g., "M/D/YYYY" or "DD/MM/YYYY")
            return date.toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
            // Alternatively, for a simple date and time:
            // return date.toLocaleString();
          };

          return {
            id: order._id, // for DataGrid's internal use
            orderId: order.orderId || "",
            customer: order.fullName || "",
            brand: order.brand || "",
            city: order.city || "",
            // === MODIFICATION HERE ===
            createdAt: formatDate(order.createdAt),
            // =========================
            address: order.address || "",
            homeName: order.homeName || "",
            email: order.email || "",
            phone: order.phone || "",
            landmark: order.landmark || "",
            orderStatus: order.orderStatus || "",
            paymentMethod: order.paymentMethod || "",
            paymentStatus: order.paymentStatus || "",
            totalAmount: order.totalAmount || 0,
            deliveryCost: order.deliveryCost || 0,
            productsList: order.products || [],
          };
        });

        setOrders(mappedOrders);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };

    getAllOrders();
  }, []);

  const handleOrderId = (orderId) => {
    setSelectOrderId(orderId);
    setIsModalOpen(true);
  };

  return (
    <>
      <SlideInModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      >
        <OrderView orderId={selectOrderId} />
      </SlideInModal>
      <div className="main_wrp">
        {loading ? (
          <Loading />
        ) : (
          <div className="main_page_wrp">
            <div className="head_wrp">
              <h5>
                All <em>Orders</em>
              </h5>
            </div>
            <div className="main_body_wrp">
              <DataGrid
                rows={orders}
                columns={columns}
                pageSize={5}
                disableRowSelectionOnClick
                getRowId={(row) => row.id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                onCellClick={(params) => handleOrderId(params.row.id)}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Orders;
